import $ from 'jquery'
import Swiper from 'swiper'

export default () => {
  $(() => {
    if (!$('body').hasClass('post-type-archive-project')) return

    new Swiper('.section-category .swiper-container', {
      slidesPerView: window.WP_VAR.slidesPerViewMobile,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
    })
  })
}
